import { DistanceUnitEnum } from '~/enums/distance-unit'
import type { CountryCodes } from '~/types/api'

export default (countryCode: CountryCodes) => (countryCode === 'US' ? DistanceUnitEnum.MI : DistanceUnitEnum.KM)
